<template>
  <aside class="p-5" data-testid="student-details-sidebar">
    <div class="actions mb-4" data-testid="student-sidebar-actions">
      <slot name="actions"></slot>
    </div>
    <div class="mt-4" data-testid="details-section-slot">
      <slot></slot>
    </div>
  </aside>
</template>
